import React, { useEffect, useState, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { IoMdDownload } from 'react-icons/io';

const ExportCalib = ({ iframe, port_calib_downloader }) => {
  const { t } = useTranslation();
  const [downloadedFiles, setDownloadedFiles] = useState([]);
  const logRef = useRef(null);

  const downloadQueue = useRef([]);
  const processing = useRef(false);
  const wsRef = useRef(null);
  const reconnectTimeout = useRef(null);

  let url = '';
  try {
    url = new URL(iframe).hostname;
  } catch (e) {
    console.error('Invalid iframe URL:', iframe);
  }

  const pathSuffix = `/${port_calib_downloader}/calib/files`;
  const wsProtocol = window.location.hostname === 'localhost' ? 'ws' : 'wss';
  const wsUrl = `${wsProtocol}://${url}${pathSuffix}`;

  const setupWebSocket = () => {
    if (wsRef.current && wsRef.current.readyState !== WebSocket.CLOSED) return;

    const ws = new WebSocket(wsUrl);
    wsRef.current = ws;

    ws.onopen = () => {
      console.log('WebSocket connected');
    };

    ws.onmessage = (event) => {
      try {
        const { filename } = JSON.parse(event.data);
        downloadQueue.current.push(filename);
        if (!processing.current) {
          processQueue();
        }
      } catch (err) {
        console.error('Invalid WebSocket message format:', event.data);
      }
    };

    ws.onerror = (err) => {
      console.error('WebSocket error:', err);
    };

    ws.onclose = (e) => {
      console.warn('WebSocket closed:', e.reason);
      setupWebSocket();
      console.log('Reconnecting WebSocket...');
    };
  };

  useEffect(() => {
    setupWebSocket();
    const reconnectTimeoutValue = reconnectTimeout.current;

    return () => {
      if (reconnectTimeoutValue) {
        clearTimeout(reconnectTimeoutValue);
      }
      if (
        wsRef.current &&
        (wsRef.current.readyState === WebSocket.OPEN ||
          wsRef.current.readyState === WebSocket.CONNECTING)
      ) {
        wsRef.current.close();
      }
    };
  }, [port_calib_downloader, wsUrl]);

  const processQueue = async () => {
    if (processing.current || downloadQueue.current.length === 0) return;

    processing.current = true;

    const filename = downloadQueue.current.shift();
    await downloadFile(filename);

    setDownloadedFiles((prevFiles) => {
      if (!prevFiles.includes(filename)) {
        return [...prevFiles, filename];
      }
      return prevFiles;
    });

    processing.current = false;
    processQueue();
  };

  const downloadFile = async (filename) => {
    const fullUrl = `${window.location.protocol}//${url}${pathSuffix}/${filename}`;

    try {
      const response = await fetch(fullUrl);
      if (!response.ok) throw new Error('Download failed');

      const blob = await response.blob();
      const blobUrl = window.URL.createObjectURL(blob);

      const a = document.createElement('a');
      a.href = blobUrl;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(blobUrl);
    } catch (err) {
      console.error('Error downloading file:', err);
    }
  };

  return (
    <div>
      <div className="bg-ascorel">
        <h2 className="h4 ms-4 mt-4 text-white">{t('title_calib_download')}</h2>
      </div>
      <ul ref={logRef} className="list-group mt-4">
        {downloadedFiles.map((file, index) => (
          <li
            key={index}
            className="list-group-item d-flex align-items-center fs-4"
          >
            <a
              href={`${window.location.protocol}//${url}${pathSuffix}/${file}`}
              download={file}
              className="text-decoration-none text-primary"
            >
              <IoMdDownload /> {file}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default ExportCalib;
